import { TFunction, Trans } from "react-i18next";
import { MessagesMessage } from "primereact/messages";

export default function PurchaseReportVerifiedMessage(t: TFunction): MessagesMessage {
    return {
        sticky: true,
        severity: "success",
        closable: false,
        detail: (
            <p className="verifiedMessage">
                <Trans i18nKey="toasts.verifyEmailMessage" t={t}>
                    <strong style={{ color: "#2a681b" }}>Success</strong> Thank you for verifying your email
                </Trans>
            </p>
        )
    }
}